import { WprBaseScopeInfo } from '../wpr-framework/scope/WprBaseScopeInfo';
import { ContractorInfo } from '../models/ContractorInfo';
import { TravelerInfo } from '../models/TravelerInfo';
import { LoginInfo } from '../models/LoginInfo';
import { PlanInfo } from '../models/PlanInfo';
import { ContractNoticeInfo } from '../service/models/contract-notice/contract-notice-info';
import { ContractNoticeRequest } from '../service/service-models/contract-notice/ContractNoticeReqesut';
import { ContractNoticeResult } from '../service/service-models/contract-notice/ContractNoticeResult';
import { SelectPlanInfo } from '../service/models/select-plan/select-plan-info';
import { RiskFactorInfo } from '../service/models/risk-factor/risk-factor-info';
import { AuthMailInfo } from '../service/models/auth-mail/auth-mail-info';
import { OthersInfo } from '../models/OthersInfo';

/**
 * 前半スコープ情報
 */
export class FirstScopeInfo extends WprBaseScopeInfo {
	// コンストラクタ  -----------------------------------------------------------
	public constructor() { 
		super('前半スコープ情報'); 
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
     * 初期化通知
     */
	public onInitialize(): void {
		// 旅行内容情報
		const riskFactorInfo = new RiskFactorInfo();
		this.setScopeModel('RiskFactorInfo',	riskFactorInfo);
		// 保険プラン詳細情報
		const planInfo = new PlanInfo();
		this.setScopeModel('PlanInfo',			planInfo);
		// 選択プラン情報
		const selectPlanInfo = new SelectPlanInfo();
		this.setScopeModel('SelectPlanInfo', selectPlanInfo);
		// 認証メール情報
		const authMailInfo = new AuthMailInfo();
		this.setScopeModel('AuthMailInfo', 	authMailInfo);
		// その他情報
		const othersInfo = new OthersInfo();
		this.setScopeModel('OthersInfo', othersInfo);
		// 告知事項
		// const contractNoticeList = [];
		// for (let i = 0; i < 5; i++)
		// 	contractNoticeList.push(new ContractNoticeInfo());
		// this.setScopeModel('ContractNoticeInfo', contractNoticeList);
	}
	// --------------------------------------------------------------------------
}